export const comments_3257645 = {"data":{"data":[],"links":{}}}